import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const BookingHistoryDetailHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Booking Detail</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default BookingHistoryDetailHeader;
